import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-3 -3 22 22",
	stroke: "currentColor",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.0344 0.941162L0.94118 15.0344",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.965576 0.941162L15.0588 15.0344",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgClose;
